export class PollingService {
  async startPolling(
    pollingFunction: () => Promise<void>,
    interval: number,
    condition: () => Promise<boolean>,
  ) {
    const poll = async () => {
      try {
        if (await condition()) await pollingFunction();
      } catch (error) {
        console.error("Polling error:", error);
      }
      setTimeout(poll, interval);
    };
    await poll();
  }
}
